// extracted by mini-css-extract-plugin
module.exports = {"main":"GenericBanner_main__uK2KN","image":"GenericBanner_image__7JkPH","icon":"GenericBanner_icon__ovP_Z","texts":"GenericBanner_texts__SYtqd"};